import React from "react";
import { Button, Modal } from "react-bootstrap";

interface BtnType {
  text: string;
  action: Function;
  variant?: string;
  className?: string;
}

interface ConfirmationModalType {
  show: boolean;
  heading: string;
  message: string;
  buttons?: BtnType[] | null;
  closeModal?: Function;
}

const ConfirmationModal: React.FC<ConfirmationModalType> = ({
  show,
  closeModal,
  heading,
  message,
  buttons = null,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        if (closeModal) closeModal();
      }}
      className="conrfimation-modal-wrapper"
    >
      <Modal.Header closeButton={closeModal ? true : false}>
        {heading}
      </Modal.Header>

      <Modal.Body>
        <div className="confirmation-text">{message}</div>
      </Modal.Body>

      <Modal.Footer>
        {buttons &&
          buttons?.length > 0 &&
          buttons?.map((item, index) => (
            <Button
              key={`confirmation-btn-${index}`}
              variant={item.variant}
              className={item.className}
              onClick={() => {
                if (item.action) {
                  item.action();
                }
              }}
            >
              {item.text}
            </Button>
          ))}
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
